module.exports = __webpack_public_path__ + "img/4.560f6c9c.jpg";